import React from 'react'
import { MdAddCall } from "react-icons/md";
const AddressBar = () => {
  return (
    <div>
      <div className="w-full bg-green-800 text-white py-1 px-2">
            <div className="max-w-7xl md:text-sm text-[7px] mx-auto flex flex-row md:flex-row justify-between items-center space-y-1 md:space-y-0">
              <div className="flex items-center space-x-1">
                {/* <PiBuildingOffice className="mx-2 font-medium size-6"/>
                <span>
                 MZ 01 B Zone Business Spaces, Nipaniya Square  INDORE MADHYA PRADESH,452010
                </span> */}
              </div>
              <div className="flex items-center space-x-1">
                <MdAddCall className="mx-2 font-medium size-6"/>
                <span>+91 9891904233</span>
              </div>
            </div>
          </div>
    </div>
  )
}

export default AddressBar
